import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { getMuiTableDataIndex } from '../helpers/getters';
import BaseMUIDataTable from './BaseMUIDataTable/BaseMUIDataTable';
import ButtonWithLoading from './ButtonWithLoading';
import { Colors } from '../assets/theme/Colors';

const AppConfigBulkEditReviewAndSave = ({ onExit, onSave, dialogOpen, editesSites, sites, isLoading }) => {
  const editedSitesPreviousData = sites.filter((site) => editesSites.some((s) => s.site_id === site.id));

  const sitesData =
    editedSitesPreviousData &&
    editedSitesPreviousData.map((site) => {
      const editedSite = editesSites.find((s) => s.site_id === site.id);
      return { ...site, newData: editedSite };
    });

  const nameCustomBodyRender = (value, tableMeta) => {
    const site = sitesData[getMuiTableDataIndex(tableMeta)];

    return (
      <>
        {site.name}

        {site && site.disabled_at !== null && (
          <>
            <br />

            <span style={{ color: Colors.sites.disabled.color, fontWeight: 'bold' }}>Disabled</span>
          </>
        )}
      </>
    );
  };

  const editsCustomBodyRender = (value) => {
    const edits = [];

    if (value.featureFlags) {
      const editedFlagsArray = Object.values(value.featureFlags);

      editedFlagsArray.forEach((ff) => {
        edits.push({ checked: ff.checked, fieldName: ff.name });
      });
    }

    const modifiedFields = edits.reduce(
      (acc, field) => [
        ...acc,
        <Box key={field.fieldName} display="flex" alignItems="center">
          <Box>
            <u>{field.fieldName}</u>:
          </Box>
          <Box px={1}>
            {field.checked ? (
              <strong style={{ color: Colors.green.main }}>On</strong>
            ) : (
              <strong style={{ color: Colors.red }}>Off</strong>
            )}
          </Box>
        </Box>,
      ],
      []
    );

    return <Box>{modifiedFields}</Box>;
  };

  return (
    <Dialog open={dialogOpen} maxWidth="md" fullWidth onBackdropClick={onExit}>
      <DialogTitle>Review and Save</DialogTitle>
      <DialogContent>
        <BaseMUIDataTable
          isLoading={!sitesData.length}
          tableId="#pastrescues/editedRescues"
          data={sitesData}
          columns={[
            {
              name: 'id',
              label: 'Site Id',
              options: {
                display: true,
                filter: false,
              },
            },
            {
              name: 'name',
              label: 'Site Name',
              options: {
                display: true,
                filter: false,
                customBodyRender: (value, tableMeta) => nameCustomBodyRender(value, tableMeta),
              },
            },
            {
              name: 'newData',
              label: 'Edits',
              options: {
                forceDisplay: true,
                customBodyRender: (value) => editsCustomBodyRender(value),
              },
            },
          ]}
          options={{
            sortOrder: {
              name: 'date',
              direction: 'desc',
            },
            sort: false,
            filter: false,
            download: false,
            search: false,
            viewColumns: false,
            pagination: false,
            elevation: 0,
            selectableRows: 'none',
            responsive: 'simple',
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onExit}>Back</Button>
        <ButtonWithLoading isLoading={isLoading} onClick={() => onSave(sitesData)}>
          Save
        </ButtonWithLoading>
      </DialogActions>
    </Dialog>
  );
};

export default AppConfigBulkEditReviewAndSave;
